import React from 'react';
import { AlertCircle, FileText, Filter } from 'lucide-react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

type ReportsEmptyStateProps = {
  title: string;
  description?: React.ReactNode;
  icon?: 'filter' | 'file' | 'error';
  children?: React.ReactNode;
};

export function ReportsEmptyState({
  title,
  description,
  icon = 'file',
  children,
}: ReportsEmptyStateProps) {
  const Icon = icon === 'error' ? AlertCircle : icon === 'filter' ? Filter : FileText;

  return (
    <Empty className="tw:border-border">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        {description ? <EmptyDescription>{description}</EmptyDescription> : null}
      </EmptyHeader>
      {children ? <EmptyContent>{children}</EmptyContent> : null}
    </Empty>
  );
}
